import type { ReactNode } from "react";
import { FaixaAmbiente, Marca } from "@plantus/ui";

import { usarAmbiente } from "../ambiente/ProvedorDeAmbiente";

/**
 * A moldura das telas de entrada.
 *
 * <p>A `FaixaAmbiente` aparece **também aqui**, antes de qualquer login.
 * Quem está digitando a senha já precisa saber onde está entrando — se a
 * identificação só aparecesse depois, a pessoa entregaria a credencial
 * sem saber a qual ambiente.
 */
export function Moldura({ children }: { children: ReactNode }) {
  const { ambiente, versao, commit } = usarAmbiente();

  return (
    <div className="moldura">
      <FaixaAmbiente ambiente={ambiente} />

      <main className="moldura__centro">
        {/* A variante `institucional` porque o fundo aqui é CLARO: ela traz a
            própria placa verde-900 com o símbolo vazado (15.23:1). O quadrado
            desenhado à mão em `app.css` — um "P" numa caixa — saiu junto:
            marca escrita na folha de estilo é marca que não acompanha a troca
            do logotipo, e é a etiqueta impressa que paga essa conta. */}
        <Marca
          variante="institucional"
          tamanho="grande"
          apoio="Gestão regulatória e da qualidade"
        />

        {children}
      </main>

      <footer className="moldura__rodape">
        {versao !== null && (
          <span>
            versão {versao} · {commit}
          </span>
        )}
      </footer>
    </div>
  );
}
